import * as React from "react";
import { cn } from "@/shared/lib/class.util";

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  checked: boolean;
  setChecked: (checked: boolean) => void;
  link?: React.ReactNode;
  checkedColor?: string;
  uncheckedColor?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      checked,
      setChecked,
      checkedColor = "#009EFF",
      uncheckedColor = "#c0c0c0",
      link,
      id,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <label
        className={cn(
          "flex cursor-pointer items-center gap-[4px] text-gray-400",
          className
        )}
        htmlFor={id}
      >
        <input
          type="checkbox"
          className="hidden"
          id={id}
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_127_1648)">
            <path
              d="M18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4Z"
              fill={checked ? checkedColor : uncheckedColor}
            />
            <path
              d="M9 12L11 14L15 10"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_127_1648">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {link || <span className="">{label || ""}</span>}
      </label>
    );
  }
);
Checkbox.displayName = "Checkbox";
export { Checkbox };
